class Author {
  async get(filter) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/authors?q=${filter}`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }

  async addUpdate(author) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/authors/${author.id || ''}`, {
      method: author.id ? 'PUT' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token')
      },
      body: JSON.stringify(author)
    });
    return await data.json();
  }

  async delete(author) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/authors/${author.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }
}

module.exports = new Author();